import { useIntl } from 'react-intl';
import { SharedDatasetManagerRepositoryOperationLogModelOperationStatus } from '@rossum/mdh-api-client';
import { IconCircle } from '@rossum/ui/icons/tabler';
import { Chip, Stack, SvgIcon, Typography } from '@rossum/ui/material';
import { GridRenderCellParams } from '@rossum/ui/x-data-grid-pro';
import { TransformedOperation } from '../helpers';

const CHIP_MAX_WIDTH = 160;

const circleColor = {
  WAITING: { color: 'info' },
  IN_PROGRESS: { color: 'info' },
  FINISHED: { color: 'success' },
  FAILED: { color: 'error' },
  UNKNOWN: { color: 'warning' },
} as const satisfies Record<
  SharedDatasetManagerRepositoryOperationLogModelOperationStatus,
  unknown
>;

const intlKeys = {
  WAITING: 'waiting',
  IN_PROGRESS: 'inProgress',
  FINISHED: 'finished',
  FAILED: 'failed',
  UNKNOWN: 'unknown',
} as const satisfies Record<
  SharedDatasetManagerRepositoryOperationLogModelOperationStatus,
  string
>;

export const StatusChip = ({
  value: status,
}: GridRenderCellParams<
  TransformedOperation,
  SharedDatasetManagerRepositoryOperationLogModelOperationStatus
>) => {
  const intl = useIntl();
  if (!status) return null;

  return (
    <Chip
      data-cy="operation-status-chip"
      data-status={status}
      sx={{
        maxWidth: CHIP_MAX_WIDTH,
        cursor: 'inherit',
      }}
      variant="filled"
      color={circleColor[status].color}
      size="small"
      label={
        <Stack direction="row" alignItems="center" gap={0.5}>
          <Stack minWidth={18} alignItems="center">
            <SvgIcon
              fontSize="medium"
              color="inherit"
              sx={{
                transform: 'scale(0.5, 0.5)',
              }}
            >
              <IconCircle />
            </SvgIcon>
          </Stack>
          <Typography
            variant="body2"
            color="inherit"
            fontSize={13}
            sx={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              pr: 0.75,
              pt: 1 / 8,
            }}
          >
            {intl.formatMessage({
              id: `features.datasets.status.${intlKeys[status]}`,
            })}
          </Typography>
        </Stack>
      }
    />
  );
};
